module.exports = __webpack_public_path__ + "img/uruguay.fc1ca970.svg";